import Button from 'component/atom/forms/button/Button';
import Input from 'component/atom/forms/input/input/Input';
import Modal from 'component/hoc/modal/Modal';
import { useFormik } from 'formik';
import { chatEndpoints } from 'hooks/endpoints';
import { usePost } from 'hooks/usePost';
import React, { useEffect, useRef } from 'react';
import styles from '../../ChatConsoleSidebar.module.scss';
import * as Yup from 'yup';

const Form = ({ formik, onClose }) => {
  return (
    <form
      autoComplete='off'
      onSubmit={formik.handleSubmit}
      className={styles['form']}
    >
      <Input
        label='Rename'
        placeholder='Enter new name'
        name='chatTitle'
        value={formik.values.chatTitle}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.chatTitle && formik.errors.chatTitle}
      />
      <div className={styles.footer}>
        <div></div>
        <div className={styles.actions}>
          <Button onClick={onClose} label='Cancel' variant={'dark'} />
          <Button
            type='save'
            label='Update'
            inputType='submit'
            isLoading={formik.isSubmitting}
            disabled={formik.isSubmitting || !formik.values.chatTitle?.trim()}
            onClick={formik.handleSubmit}
          />
        </div>
      </div>
    </form>
  );
};

const RenameChatTitle = ({ isOpen, onClose, id, refetch, title }) => {
  const { mutate: renameChatTitle, isPending } = usePost();
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        onClose?.();
      }
    };
    document.addEventListener('mousedown', handleOutside);
    document.addEventListener('touchstart', handleOutside);
    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('touchstart', handleOutside);
    };
  }, [isOpen, onClose]);

  const validationSchema = Yup.object({
    chatTitle: Yup.string().trim().required('Folder Name is required'),
  });

  const formik = useFormik({
    initialValues: {
      chatTitle: title || '',
    },
    validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      const trimmed = values.chatTitle.trim();
      if (!trimmed) {
        setSubmitting(false);
        return;
      }

      renameChatTitle(
        {
          url: chatEndpoints.editTitle(),
          data: {
            chatId: id,
            chatTitle: trimmed,
          },
        },
        {
          onSuccess: () => {
            refetch();
            onClose();
          },
          onError: (error) => {
            console.error('Error creating folder:', error);
          },
          onSettled: () => {
            setSubmitting(false);
          },
        }
      );
    },
    enableReinitialize: true,
  });

  return (
    <div>
      <Modal
        title='Rename Chat'
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={formik.handleSubmit}
        buttonType='submit'
        isLoading={isPending}
      >
        <div ref={containerRef}>
          <Form formik={formik} onClose={onClose} />
        </div>
      </Modal>
    </div>
  );
};

export default RenameChatTitle;
